<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'signatures.installationChoiceHeader' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="installation-choice-dialog__options">
      <div class="installation-choice-dialog__option" (click)="chooseExtension()">
        <mat-icon>extension</mat-icon>
        <div class="installation-choice-dialog__option-content">
          <h3>{{ 'signatures.installForYourself' | translate }}</h3>
          <p>{{ 'signatures.installChromeExtension' | translate }}</p>
        </div>
      </div>

      <div class="installation-choice-dialog__option" (click)="chooseMarketplace()">
        <mat-icon>business</mat-icon>
        <div class="installation-choice-dialog__option-content">
          <h3>{{ 'signatures.testInOrganization' | translate }}</h3>
          <p>{{ 'signatures.installFromMarketplace' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()">
      {{ 'cancel' | translate }}
    </button>
  </footer>
</div>
